import Map, {
    Popup
  } from "react-map-gl";
import { colors } from "../utils/colorDict";

const InfoPopup=({title,lngLat,handlePopupData,selectedMedia})=> <Popup
      style={{ color: colors[selectedMedia] }}
      longitude={lngLat[0]}
      latitude={lngLat[1]}
      onClose={() => handlePopupData(null)}
      closeButton={false}
    >
      {title}
    </Popup>

export default InfoPopup